export default __webpack_public_path__ + "cccf94e07723dc0077bfb5dfeccd0067.png";